/**
 * The tier-change pop-up's vocabulary, in a leaf module of its own.
 *
 * It lives beside the component rather than inside it because the promo-material
 * resolver maps the server's movement directions onto these values, and that
 * resolver sits in the app-wide bundle (`PromoPopupProvider` is mounted in
 * `_app`). Importing the enum *from the component* made that a value import, so
 * the whole pop-up — confetti, tier artwork, i18n — was pulled out of its code
 * split and into the shared chunk: +21 kB on first load, which the bundle-size
 * ratchet caught.
 */
export enum TierChangeKind {
  UPGRADE = "upgrade",
  STEADY = "steady",
  DOWNGRADE = "downgrade",
}
